var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-bitwise */
import { isRaster } from './utility';
const minHeightWidth = 1000;
function createSingleColor(imgData, color) {
    const pixels = imgData.data;
    for (let i = 0; i < pixels.length; i += 4) {
        const lightness = pixels[i + 1] > 191 ? 255 : 0;
        pixels[i] = color[0];
        pixels[i + 1] = color[1];
        pixels[i + 2] = color[2];
        if (lightness !== 0) {
            pixels[i + 3] = 0;
        }
    }
    return imgData;
}
export function getSingleColorImage(file) {
    if (!file) {
        throw new Error(`File is empty`);
    }
    if (!isRaster(file)) {
        throw new Error(`file is not supported`);
    }
    return new Promise((resolve, reject) => {
        try {
            const img = document.createElement('img');
            const blobUrl = URL.createObjectURL(file);
            img.src = blobUrl;
            let width = 0;
            let height = 0;
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            img.onerror = (error) => {
                throw new Error(`Error while fetching image: ${error}`);
            };
            img.src = blobUrl;
            // eslint-disable-next-line func-names
            img.onload = () => {
                try {
                    width = img.width;
                    height = img.height;
                    let reductionPercentage = 1;
                    if (minHeightWidth < 1000000) {
                        if (height < width) {
                            reductionPercentage = minHeightWidth / height;
                        }
                        else {
                            reductionPercentage = minHeightWidth / width;
                        }
                    }
                    width *= reductionPercentage;
                    height *= reductionPercentage;
                    canvas.height = height;
                    canvas.width = width;
                    img.height = height;
                    img.width = width;
                    if (!ctx)
                        return;
                    ctx.drawImage(img, 0, 0, width, height);
                    let imgData = ctx.getImageData(0, 0, ctx.canvas.width, ctx.canvas.height);
                    /* process image data */
                    const pixels = ctx.getImageData(0, 0, canvas.width, canvas.height);
                    const colors = {};
                    /* pixel data 4 bits: red,green,blue then alpha */
                    for (let i = 0; i < pixels.data.length; i += 4) {
                        if (pixels.data[i + 3] !== 0) {
                            const curColor = `${pixels.data[i]}|${pixels.data[i + 1]}|${pixels.data[i + 2]}`;
                            colors[curColor] = colors[curColor] ? colors[curColor] + 1 : 1;
                        }
                    }
                    const totalK = Object.keys(colors).length;
                    // eslint-disable-next-line camelcase
                    const pallete_rgb = [];
                    if (totalK < 1) {
                        // eslint-disable-next-line consistent-return
                        return null;
                    }
                    if (totalK === 1) {
                        pallete_rgb[0] = colors.keys()[0].split('|').map(Number);
                    }
                    else {
                        /* sort array */
                        const sortedC = [];
                        // eslint-disable-next-line guard-for-in
                        for (const key in colors)
                            sortedC.push(key);
                        // eslint-disable-next-line prefer-arrow-callback
                        sortedC.sort((a, b) => colors[b] - colors[a]);
                        for (let i = 0; i < Math.min(sortedC.length, 5); i++) {
                            const rgb = sortedC[i].split('|').map(Number);
                            pallete_rgb[i] = rgb;
                        }
                    }
                    imgData = createSingleColor(imgData, pallete_rgb[0]);
                    ctx.putImageData(imgData, 0, 0);
                    canvas.toBlob((blob) => __awaiter(this, void 0, void 0, function* () {
                        if (blob) {
                            resolve(blob);
                        }
                        else {
                            reject(new Error('some error ocurred'));
                        }
                    }), 'image/png');
                    return;
                }
                catch (exception) {
                    throw new Error('Exception while processing singleColorImage on Image Load');
                }
            };
            // document.body.appendChild(canvas);
        }
        catch (exception) {
            throw new Error('Exception while processing imageInfo');
        }
    });
}
//# sourceMappingURL=singleColor.js.map